import { render, staticRenderFns } from "./AllAdminViewAssignTagOnAccountSDData.vue?vue&type=template&id=49a97bee&scoped=true"
import script from "./AllAdminViewAssignTagOnAccountSDData.vue?vue&type=script&lang=js"
export * from "./AllAdminViewAssignTagOnAccountSDData.vue?vue&type=script&lang=js"
import style0 from "./AllAdminViewAssignTagOnAccountSDData.vue?vue&type=style&index=0&id=49a97bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a97bee",
  null
  
)

export default component.exports